var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuscussionDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.583 3.375h1.834a3.667 3.667 0 110 7.333v1.604c-2.292-.916-5.5-2.291-5.5-5.27a3.667 3.667 0 013.666-3.667zm.917 6.417h.917a2.75 2.75 0 100-5.5h-1.834a2.75 2.75 0 00-2.75 2.75c0 1.654 1.129 2.734 3.667 3.886V9.792zm-8.917.583h1.834a3.667 3.667 0 110 7.333v1.605c-2.292-.917-5.5-2.292-5.5-5.271a3.667 3.667 0 013.666-3.667zm.917 6.417h.917a2.75 2.75 0 100-5.5H9.583a2.75 2.75 0 00-2.75 2.75c0 1.654 1.129 2.734 3.667 3.886v-1.136z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.417 1.375H4.583a3.667 3.667 0 100 7.333v1.604c2.292-.916 5.5-2.291 5.5-5.27a3.667 3.667 0 00-3.666-3.667zM5.5 7.792h-.917a2.75 2.75 0 110-5.5h1.834a2.75 2.75 0 012.75 2.75c0 1.654-1.129 2.734-3.667 3.886V7.792z"
  }))));
}
export default SvgDuscussionDisabled;